package br.com.htms.inspeccaocampo.data.checklist

object ChecklistCatalog {
    val tipos: List<ChecklistTipo> = listOf(
        ChecklistTipo(
            id = "ve_culos_leves",
            nome = "Veículos Leves",
            titulo = "Formulário de Inspeção Diária de Segurança  (Veículos Leves)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível / Nível"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Extintor"),
                ChecklistItemDef(14, "Buzina"),
                ChecklistItemDef(15, "Nível de óleo"),
                ChecklistItemDef(16, "Nível de água"),
                ChecklistItemDef(17, "Pneus dianteiros; Pneus traseiros; Pneu de estepe;"),
                ChecklistItemDef(18, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(19, "Retrovisores interno e externo"),
                ChecklistItemDef(20, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(21, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(22, "Motor: Partida; Motor: Funcionamento;"),
                ChecklistItemDef(23, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(24, "Logotipo da empresa"),
                ChecklistItemDef(25, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "caminhonete",
            nome = "Caminhonete",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhonete)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível / Nível"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Vedação e trava da tampa traseira"),
                ChecklistItemDef(26, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "toyota_bandeirantes",
            nome = "Toyota Bandeirantes",
            titulo = "Formulário de Inspeção Diária de Segurança  (Toyota Bandeirantes)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso"),
                ChecklistItemDef(29, "Capacidade de pessoas"),
                ChecklistItemDef(30, "ANTT"),
                ChecklistItemDef(31, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(32, "Crachá"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "toyota_cabine_dupla",
            nome = "Toyota Cabine Dupla",
            titulo = "Formulário de Inspeção Diária de Segurança  (Toyota Cabine Dupla)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível / Nível"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Vedação e trava da tampa traseira"),
                ChecklistItemDef(26, "Existe disponível no veículo lista dos hospitais conforme PAE"),
                ChecklistItemDef(27, "Crachá"),
            )
        ),
        ChecklistTipo(
            id = "ambul_ncia",
            nome = "Ambulância",
            titulo = "Formulário de Inspeção Diária de Segurança  (Ambulância)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível / Nível"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Extintor"),
                ChecklistItemDef(14, "Buzina"),
                ChecklistItemDef(15, "Nível do óleo"),
                ChecklistItemDef(16, "Nível de água"),
                ChecklistItemDef(17, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(18, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(19, "Retrovisores Externo"),
                ChecklistItemDef(20, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(21, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(22, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(23, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(24, "Vedação e trava da tampa traseira"),
                ChecklistItemDef(25, "Giroflex e Sirene"),
                ChecklistItemDef(26, "Existe janela de comunicação entre o motorista e paciente"),
                ChecklistItemDef(27, "Existe banco para o acompanhante no compartimento do paciente"),
                ChecklistItemDef(28, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(29, "Logotipo da Empresa"),
                ChecklistItemDef(30, "Possui suporte para soro"),
                ChecklistItemDef(31, "Possui mascara, cilindro de oxigênio"),
                ChecklistItemDef(32, "Possui disponível coletes refletivos para atendimento em rodovias"),
                ChecklistItemDef(33, "Kit de Primeiros Socorros"),
                ChecklistItemDef(34, "Maca / Luvas / Talas de Imobilização"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_basculante",
            nome = "Caminhão Basculante",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Basculante)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso"),
                ChecklistItemDef(29, "Vedação da tampa traseira"),
                ChecklistItemDef(30, "ANTT"),
                ChecklistItemDef(31, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(32, "Crachá"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_cabinado",
            nome = "Caminhão Cabinado",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Cabinado)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores externos"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Alarme sonoro motorista com a cabine"),
                ChecklistItemDef(27, "Faixas refletivas"),
                ChecklistItemDef(28, "Tacógrafo"),
                ChecklistItemDef(29, "Escada de acesso a carroceria"),
                ChecklistItemDef(30, "A carroceria está em bom estado e não há ferramentas soltas"),
                ChecklistItemDef(31, "Capacidade de pessoas"),
                ChecklistItemDef(32, "ANTT"),
                ChecklistItemDef(33, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(34, "Crachá"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_munck",
            nome = "Caminhão Munck",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Munck)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro, Horímetro e  Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso a corroceria"),
                ChecklistItemDef(29, "Patolas e abertura das sapatas estão em perfeito estado"),
                ChecklistItemDef(30, "O hidraulico da lança, giro, patolas e sapatas estão em bom estado"),
                ChecklistItemDef(31, "A mesa de giro, lança e sapatas estão isentas de trincas"),
                ChecklistItemDef(32, "A carroceria está em bom estado e não há ferramentas soltas"),
                ChecklistItemDef(33, "As travas e pinos de segurança estão em perfeito estado"),
                ChecklistItemDef(34, "As alavancas de comando estão em bom estado"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_toco",
            nome = "Caminhão Toco",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Toco)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso a carroceria"),
                ChecklistItemDef(29, "A carroceria está em bom estado e não há ferramentas soltas"),
                ChecklistItemDef(30, "ANTT"),
                ChecklistItemDef(31, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(32, "Crachá"),
                ChecklistItemDef(30, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "guindaste",
            nome = "Guindaste",
            titulo = "Formulário de Inspeção Diária de Segurança  (Guindaste)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro, Horímetro e  Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré e sirene"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso"),
                ChecklistItemDef(29, "Patolas e abertura das sapatas estão em perfeito estado"),
                ChecklistItemDef(30, "O hidraulico da lança, giro, patolas e sapatas estão em bom estado"),
                ChecklistItemDef(31, "A mesa de giro, lança e sapatas estão isentas de trincas"),
                ChecklistItemDef(32, "As travas e pinos de segurança estão em perfeito estado"),
                ChecklistItemDef(33, "As alavancas de comando estão em bom estado"),
                ChecklistItemDef(34, "Moitão possui trava, está em bom estado e não apresenta deformidades"),
            )
        ),
        ChecklistTipo(
            id = "nibus",
            nome = "Ônibus",
            titulo = "Formulário de Inspeção Diária de Segurança  (Ônibus)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Capacidade de pessoas"),
                ChecklistItemDef(29, "ANTT"),
                ChecklistItemDef(30, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(31, "Crachá"),
                ChecklistItemDef(32, "Kit de primeiros socorros"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "micro_nibus",
            nome = "Micro Ônibus",
            titulo = "Formulário de Inspeção Diária de Segurança  (Micro Ônibus)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Capacidade de pessoas"),
                ChecklistItemDef(29, "ANTT"),
                ChecklistItemDef(30, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(31, "Crachá"),
                ChecklistItemDef(32, "Kit de primeiros socorros"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme previsto no PAE"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_betoneira",
            nome = "Caminhão Betoneira",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Betoneira)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada com corrente e quarda-corpo na entrada da plataforma"),
                ChecklistItemDef(29, "As alavancas de controles estão em perfeita condições e devidamente identificadas"),
                ChecklistItemDef(30, "ANTT"),
                ChecklistItemDef(31, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(32, "Crachá"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme previsto no PAE"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_perfuratriz",
            nome = "Caminhão Perfuratriz",
            titulo = "Formulário de Inspeção Diária de Segurança  (CAMINHÃO PERFURATRIZ)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras / traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas / Buzina"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Tacógrafo"),
                ChecklistItemDef(16, "Nível do óleo / Nível de água"),
                ChecklistItemDef(17, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(18, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(19, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(20, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(21, "Fechamento portas dianteiras;"),
                ChecklistItemDef(22, "Motor: Partida / Funcionamento"),
                ChecklistItemDef(23, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(24, "Alarme sonoro de ré"),
                ChecklistItemDef(25, "Faixas refletivas"),
                ChecklistItemDef(26, "Escadas / guarda corpos apropriados"),
                ChecklistItemDef(27, "As partes móveis estão protegidas"),
                ChecklistItemDef(28, "Torre da perfuratriz / manômetro estão em boas condições"),
                ChecklistItemDef(29, "Mangueiras hidraúlicas / cabos de aço estão em boas condições"),
                ChecklistItemDef(30, "Possui cobertura contra intempéries para o operador"),
                ChecklistItemDef(31, "Possui Aterramento movel"),
                ChecklistItemDef(32, "ANTT"),
                ChecklistItemDef(33, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(34, "Crachá"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_comboio",
            nome = "Caminhão Comboio",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Comboio)",
            itens = listOf(
                ChecklistItemDef(1, "CNH / MOPP estão válidos"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro, Horímetro e  Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso para o tamque"),
                ChecklistItemDef(29, "Dois Calços com dimensões mínimas de 150 mm x 200 mm x 150 mm"),
                ChecklistItemDef(30, "Aterramento provisório"),
                ChecklistItemDef(31, "Quatro cones para sinalização da via"),
                ChecklistItemDef(32, "Placas de identificação de Produtos Químicos"),
                ChecklistItemDef(33, "Possui FISPQ Ficha de Informações de Segurança de Produtos Químicos"),
                ChecklistItemDef(34, "Kit de primeiros socorros"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_prancha",
            nome = "Caminhão Prancha",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Prancha)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro, Horímetro e  Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso a corroceria"),
                ChecklistItemDef(29, "Patolas  estão em perfeito estado"),
                ChecklistItemDef(30, "A carroceria está em bom estado e não há ferramentas soltas"),
                ChecklistItemDef(31, "Existem placas de sinalização, cones e fitas zebradas diponivel"),
                ChecklistItemDef(32, "Cabo de aço / Catracas estado de conservação"),
                ChecklistItemDef(33, "As travas e pinos da rampa estão em perfeito estado de segurança"),
                ChecklistItemDef(34, "Existe calço de travamento dos pneus do veículo / equipamento a ser transportado"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_pipa",
            nome = "Caminhão Pipa",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Pipa)",
            itens = listOf(
                ChecklistItemDef(1, "CNH, Crachá do motorista e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras."),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso ao Tamque e Tampa."),
                ChecklistItemDef(29, "Reservatório/ Tubulações/ Conexões e Valvulas/ estado de conservação."),
                ChecklistItemDef(30, "Conjunto de Motobomba de água (mangueira, pressurizador a gasolina, parte elétrica, acionador do motor, nivél de óleo, suporte e parafusos)."),
                ChecklistItemDef(31, "ANTT"),
                ChecklistItemDef(32, "Existe radio de comunicação e o mesmo funciona."),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "caminh_o_ba",
            nome = "Caminhão Baú",
            titulo = "Formulário de Inspeção Diária de Segurança  (Caminhão Baú)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras/Baú."),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Escada de acesso ao Baú"),
                ChecklistItemDef(29, "A carroceria / Baú está em bom estado e não há ferramentas soltas."),
                ChecklistItemDef(30, "ANTT"),
                ChecklistItemDef(31, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(32, "Crachá"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme PAE"),
            )
        ),
        ChecklistTipo(
            id = "vam",
            nome = "Vam",
            titulo = "Formulário de Inspeção Diária de Segurança  (Van)",
            itens = listOf(
                ChecklistItemDef(1, "CNH e Documento do veículo"),
                ChecklistItemDef(2, "Cintos de segurança"),
                ChecklistItemDef(3, "Lanternas dianteiras; Lanternas  traseiras"),
                ChecklistItemDef(4, "Farol alto; Farol baixo"),
                ChecklistItemDef(5, "Setas"),
                ChecklistItemDef(6, "Luz de freio e de ré"),
                ChecklistItemDef(7, "Amortecedores e suspensão"),
                ChecklistItemDef(8, "Freios de serviço e estacionamento"),
                ChecklistItemDef(9, "Limpador de pára-brisa"),
                ChecklistItemDef(10, "Combustível: Nível; Travamento do tanque"),
                ChecklistItemDef(11, "Odômetro e Velocímetro"),
                ChecklistItemDef(12, "Vazamento"),
                ChecklistItemDef(13, "Logotipo da Empresa"),
                ChecklistItemDef(14, "Extintor"),
                ChecklistItemDef(15, "Buzina"),
                ChecklistItemDef(16, "Nível do óleo"),
                ChecklistItemDef(17, "Nível de água"),
                ChecklistItemDef(18, "Pneus dianteiros; Pneus traseiros; Pneu de estepe"),
                ChecklistItemDef(19, "Parafusos roda dianteira; Parafusos roda traseira"),
                ChecklistItemDef(20, "Retrovisores (Interno e Externo)"),
                ChecklistItemDef(21, "Macaco; Triângulo; Chave de rodas"),
                ChecklistItemDef(22, "Fechamento portas dianteiras; Fechamento portas traseiras"),
                ChecklistItemDef(23, "Motor: Partida ; Motor: Funcionamento"),
                ChecklistItemDef(24, "Bancos: estofamento; Limpeza; Organização"),
                ChecklistItemDef(25, "Alarme sonoro de ré"),
                ChecklistItemDef(26, "Faixas refletivas"),
                ChecklistItemDef(27, "Tacógrafo"),
                ChecklistItemDef(28, "Capacidade de pessoas"),
                ChecklistItemDef(29, "ANTT"),
                ChecklistItemDef(30, "Existe radio de comunicação e o mesmo funciona"),
                ChecklistItemDef(31, "Crachá"),
                ChecklistItemDef(32, "Kit de primeiros socorros"),
                ChecklistItemDef(33, "Existe disponível no veículo lista dos hospitais conforme previsto no PAE"),
            )
        ),
        ChecklistTipo(
            id = "retroescavadeira",
            nome = "Retroescavadeira",
            titulo = "Formulário de Inspeção Diária de Segurança  (Retroescavadeira)",
            itens = listOf(
                ChecklistItemDef(1, "Acendimento das luzes do painel"),
                ChecklistItemDef(2, "Acesso a cabine é adequado e está em boas condições de uso"),
                ChecklistItemDef(3, "Condições de uso dos pneus e rodas"),
                ChecklistItemDef(4, "Condições do escapamento"),
                ChecklistItemDef(5, "Condições Gerais da Limpeza"),
                ChecklistItemDef(6, "Crachá"),
                ChecklistItemDef(7, "Estado geral da estrutura mecanica (trincas, deformações, etc..)"),
                ChecklistItemDef(8, "Estado geral dos pinos e contrapinos, Braço e Concha"),
                ChecklistItemDef(9, "Estado Geral dos Vidros"),
                ChecklistItemDef(10, "Existência, Validade, Condições do Casco, carga e fixação do extintor de incêndio"),
                ChecklistItemDef(11, "Fechamento da tampa do tanque de combustivel"),
                ChecklistItemDef(12, "Fixação, Condições do banco do operador"),
                ChecklistItemDef(13, "funcioamento das luzes de emergência"),
                ChecklistItemDef(14, "Funcionamento da buzina"),
                ChecklistItemDef(15, "Funcionamento das alavancas de controle de elevação e movimentação"),
                ChecklistItemDef(16, "Funcionamento das luzes de freio"),
                ChecklistItemDef(17, "Funcionamento das luzes de ré"),
                ChecklistItemDef(18, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(19, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(20, "Funcionamento das luzes indicadoras de seta (pisca)"),
                ChecklistItemDef(21, "Funcionamento de portas e maçanetas"),
                ChecklistItemDef(22, "Funcionamento do alarme sonoro de ré"),
                ChecklistItemDef(23, "Funcionamento do Cinto de Segurança"),
                ChecklistItemDef(24, "Funcionamento do Sistema de Freio"),
                ChecklistItemDef(25, "Funcionamento dos retrovisores interno e externo"),
                ChecklistItemDef(26, "Operador Qualificado"),
                ChecklistItemDef(27, "Os EPI´s estão adequado ao risco"),
                ChecklistItemDef(28, "Vazamento de agua, oleo ou combustivel"),
                ChecklistItemDef(29, "Verificar estado geral da cabine"),
                ChecklistItemDef(30, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "minicarregadeira",
            nome = "Minicarregadeira",
            titulo = "Formulário de Inspeção Diária de Segurança  (MiniCarregadeira)",
            itens = listOf(
                ChecklistItemDef(1, "O cabeçote, cabine, lança, trava e braço de articulação estão livres de avarias e danos (trincas, dentes quebrados, etc)?"),
                ChecklistItemDef(2, "Os joystick de comando (giro, lança, direção traseira), sistema operacional e computadorizado estão funcionando?"),
                ChecklistItemDef(3, "Os assentos fixos com cinto de segurança (três pontos na frente) e enconsto de cabeça?"),
                ChecklistItemDef(4, "A buzina, sistema de freios, dispositivos de comando e chave geral para desenergização do sistema elétrico funcionando?"),
                ChecklistItemDef(5, "Os pneus  dianteiros e traseiros estão em bom estado de conservação?"),
                ChecklistItemDef(6, "Há extintor de incêndio compativel, carregado e na validade?"),
                ChecklistItemDef(7, "O sistema hidráulico, conexões, mangueiras, etc. se apresenta em boas condições sem vazamentos e com conexões por dispositivos específicos?"),
                ChecklistItemDef(8, "A luz de freio, alarme sonoro de ré, luz de marcha à ré, e transformação dos faróis alto-baixo estão funcionando?"),
                ChecklistItemDef(9, "O operador possui identificação ( cracha)?"),
                ChecklistItemDef(10, "O operador é habilitado e qualificado?"),
                ChecklistItemDef(11, "Os epi´s estão adequados e em bom estado de conservação?"),
                ChecklistItemDef(13, "APR da atividade"),
                ChecklistItemDef(14, "O Sistema de ar-condicionado está funcionando?"),
            )
        ),
        ChecklistTipo(
            id = "rolo_compactador",
            nome = "Rolo Compactador",
            titulo = "Formulário de Inspeção Diária de Segurança  (RoloCompactador)",
            itens = listOf(
                ChecklistItemDef(1, "O estado geral da cabine esta em bom estado?"),
                ChecklistItemDef(2, "O escada de acesso a cabine, corrimão e puxador estão em boas condições?"),
                ChecklistItemDef(3, "As instalações elétricas do equipamento estão em bom estado de conservação?"),
                ChecklistItemDef(4, "Os freios estão em bom estado de funcionamento?"),
                ChecklistItemDef(5, "As luzes estão em bom estado de conservação?"),
                ChecklistItemDef(6, "As rodas estão em bom estado de coservação?"),
                ChecklistItemDef(7, "O alame sonoro de ré está em perfeito estado de funcionamento?"),
                ChecklistItemDef(8, "Existe extintor de incêndio em perfeito estado de utilização?"),
                ChecklistItemDef(9, "Não há existência de vazamentos de água, óleo e/ou combustível?"),
                ChecklistItemDef(10, "O cinto de segurança está em bom estado?"),
                ChecklistItemDef(11, "A proteção superior para o operador e está em bom estado de conservação?"),
                ChecklistItemDef(12, "Os  EPIs estão adequados aos riscos, quando em atividade?"),
                ChecklistItemDef(13, "O  operador possui identificação funcional (crachá).?"),
                ChecklistItemDef(14, "O  operador possui qualificação.?"),
                ChecklistItemDef(15, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "p_carregadeira",
            nome = "Pá Carregadeira",
            titulo = "Formulário de Inspeção Diária de Segurança  (Pá Carregadeira)",
            itens = listOf(
                ChecklistItemDef(1, "Acendimento das luzes do painel"),
                ChecklistItemDef(2, "Acesso a cabine é adequado e está em boas condições de uso"),
                ChecklistItemDef(3, "Condições de uso dos pneus e rodas"),
                ChecklistItemDef(4, "Condições do escapamento"),
                ChecklistItemDef(5, "Condições Gerais da Limpeza"),
                ChecklistItemDef(6, "Crachá"),
                ChecklistItemDef(7, "Estado geral da estrutura mecanica (trincas, deformações, etc..)"),
                ChecklistItemDef(8, "Estado geral dos pinos e contrapinos, Braço e Concha"),
                ChecklistItemDef(9, "Estado Geral dos Vidros"),
                ChecklistItemDef(10, "Existência, Validade, Condições do Casco, carga e fixação do extintor de incêndio"),
                ChecklistItemDef(11, "Fechamento da tampa do tanque de combustivel"),
                ChecklistItemDef(12, "Fixação, Condições do banco do operador"),
                ChecklistItemDef(13, "funcioamento das luzes de emergência"),
                ChecklistItemDef(14, "Funcionamento da buzina"),
                ChecklistItemDef(15, "Funcionamento das luzes de freio"),
                ChecklistItemDef(16, "Funcionamento das luzes de ré"),
                ChecklistItemDef(17, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(18, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(19, "Funcionamento das luzes indicadoras de seta (pisca)"),
                ChecklistItemDef(20, "Funcionamento de portas e maçanetas"),
                ChecklistItemDef(21, "Funcionamento do alarme sonoro de ré"),
                ChecklistItemDef(22, "Funcionamento do Cinto de Segurança"),
                ChecklistItemDef(23, "Funcionamento do Sistema de Freio"),
                ChecklistItemDef(24, "Funcionamento dos retrovisores interno e externo"),
                ChecklistItemDef(25, "Operador Qualificado"),
                ChecklistItemDef(26, "Os EPI´s estão adequado ao risco"),
                ChecklistItemDef(27, "Vazamento de agua, oleo ou combustivel"),
                ChecklistItemDef(28, "Verificar estado geral da cabine"),
                ChecklistItemDef(29, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "escavadeira_hidraulica",
            nome = "Escavadeira Hidraulica",
            titulo = "Formulário de Inspeção Diária de Segurança  (Escavadeira Hidraúlica)",
            itens = listOf(
                ChecklistItemDef(1, "A concha, cabine, esteira, lança e braço de articulação estão livres de avarias e danos (trincas, dentes quebrados, etc)?"),
                ChecklistItemDef(2, "A tensão da esteira é adequada?"),
                ChecklistItemDef(3, "O alarme sonoro de ré e movimentação, buzina, sistema de freios, sistema de iluminação, instrumentos do painel, horimetro, limpador de parabrisa e esguicho, amperimetro estão livres de avarias e danos?"),
                ChecklistItemDef(4, "Há extintor de incêndio compativel, carregado e dentro da validade?"),
                ChecklistItemDef(5, "Existem espelhos retrovisores e estão em boas condições de uso?"),
                ChecklistItemDef(6, "Os roletes e roda guia estão livres de vazamentos?"),
                ChecklistItemDef(7, "O parafuso de fixação de roletes, roda guia e sapatas estão apertados?"),
                ChecklistItemDef(8, "O sistema hidráulico e comando do giro estão funcionando?"),
                ChecklistItemDef(9, "Os assentos fixos com cinto de segurança ?"),
                ChecklistItemDef(10, "A pressão do óleo e temperatura do motor, trasmissão e hidráulico estão adequados?"),
                ChecklistItemDef(11, "O operador possui identificação ( cracha)?"),
                ChecklistItemDef(12, "O operador é habilitado e qualificado?"),
                ChecklistItemDef(13, "Os epi´s estão adequados e em bom estado de conservação?"),
                ChecklistItemDef(14, "APR da atividade"),
                ChecklistItemDef(15, "Sistema de Ar Condicionado Funcionando"),
            )
        ),
        ChecklistTipo(
            id = "motoniveladora",
            nome = "Motoniveladora",
            titulo = "Formulário de Inspeção Diária de Segurança  (Motoniveladora)",
            itens = listOf(
                ChecklistItemDef(1, "Acendimento das luzes do painel"),
                ChecklistItemDef(2, "Acesso a cabine é adequado e está em boas condições de uso"),
                ChecklistItemDef(3, "Condições de uso dos pneus e rodas"),
                ChecklistItemDef(4, "Condições do escapamento"),
                ChecklistItemDef(5, "Condições Gerais da Limpeza"),
                ChecklistItemDef(6, "Crachá"),
                ChecklistItemDef(7, "Estado geral da estrutura mecanica (trincas, deformações, etc..)"),
                ChecklistItemDef(8, "Estado geral dos pinos, contra pinos e lamina"),
                ChecklistItemDef(9, "Estado Geral dos Vidros"),
                ChecklistItemDef(10, "Existência, Validade, Condições do Casco, carga e fixação do extintor de incêndio"),
                ChecklistItemDef(11, "Fechamento da tampa do tanque de combustivel"),
                ChecklistItemDef(12, "Fixação, Condições do banco do operador"),
                ChecklistItemDef(13, "funcioamento das luzes de emergência"),
                ChecklistItemDef(14, "Funcionamento da buzina"),
                ChecklistItemDef(15, "Funcionamento das alavancas de controle de elevação e movimentação"),
                ChecklistItemDef(16, "Funcionamento das luzes de freio"),
                ChecklistItemDef(17, "Funcionamento das luzes de ré"),
                ChecklistItemDef(18, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(19, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(20, "Funcionamento das luzes indicadoras de seta (pisca)"),
                ChecklistItemDef(21, "Funcionamento de portas e maçanetas"),
                ChecklistItemDef(22, "Funcionamento do alarme sonoro de ré"),
                ChecklistItemDef(23, "Funcionamento do Cinto de Segurança"),
                ChecklistItemDef(24, "Funcionamento do Sistema de Freio"),
                ChecklistItemDef(25, "Funcionamento dos retrovisores interno e externo"),
                ChecklistItemDef(26, "Operador Qualificado"),
                ChecklistItemDef(27, "Os EPI´s estão adequado ao risco"),
                ChecklistItemDef(28, "Vazamento de agua, oleo ou combustivel"),
                ChecklistItemDef(29, "Verificar estado geral da cabine"),
                ChecklistItemDef(30, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "trator_de_esteira",
            nome = "Trator de Esteira",
            titulo = "Formulário de Inspeção Diária de Segurança  (Trator de Esteira)",
            itens = listOf(
                ChecklistItemDef(1, "A concha, cabine, esteira, lança e braço de articulação estão livres de avarias e danos (trincas, dentes quebrados, etc)?"),
                ChecklistItemDef(2, "A tensão da esteira é adequada?"),
                ChecklistItemDef(3, "O alarme sonoro de ré e movimentação, buzina, sistema de freios, sistema de iluminação, instrumentos do painel, horimetro, limpador de parabrisa e esguicho, amperimetro estão livres de avarias e danos?"),
                ChecklistItemDef(4, "Há extintor de incêndio compativel, carregado e dentro da validade?"),
                ChecklistItemDef(5, "Existem espelhos retrovisores e estão em boas condições de uso?"),
                ChecklistItemDef(6, "Os roletes e roda guia estão livres de vazamentos?"),
                ChecklistItemDef(7, "O parafuso de fixação de roletes, roda guia e sapatas estão apertados?"),
                ChecklistItemDef(8, "O sistema hidráulico e comando do giro estão funcionando?"),
                ChecklistItemDef(9, "Os assentos fixos com cinto de segurança ?"),
                ChecklistItemDef(10, "A pressão do óleo e temperatura do motor, trasmissão e hidráulico estão adequados?"),
                ChecklistItemDef(11, "O operador possui identificação ( cracha)?"),
                ChecklistItemDef(12, "O operador é habilitado e qualificado?"),
                ChecklistItemDef(13, "Os epi´s estão adequados e em bom estado de conservação?"),
                ChecklistItemDef(14, "APR da atividade"),
                ChecklistItemDef(15, "Sistema de Ar Condicionado Funcionando"),
            )
        ),
        ChecklistTipo(
            id = "central_de_concreto",
            nome = "Central de Concreto",
            titulo = "Formulário de Inspeção Diária de Segurança  (Central de Concreto)",
            itens = listOf(
                ChecklistItemDef(1, "O Operador possui qualificação compatível"),
                ChecklistItemDef(2, "O Operador possui identificação funcional (crachá)"),
                ChecklistItemDef(3, "Os EPI´s estão adequados aos risco, quando em atividade?"),
                ChecklistItemDef(4, "APR da Atividade"),
                ChecklistItemDef(5, "O equipamento encontra-se aterrado"),
                ChecklistItemDef(6, "Validade, aplicação e posicionamento do extintor de incêndio"),
                ChecklistItemDef(7, "Condições das instalações elétricas"),
                ChecklistItemDef(8, "Regularidade e acendimento das luzes e comando do painel"),
                ChecklistItemDef(9, "Estado e funcionamento do botão liga/desliga de segurança"),
                ChecklistItemDef(10, "Estado de limpeza do local de trabalho"),
                ChecklistItemDef(11, "Condições da rampa de acesso à balança"),
                ChecklistItemDef(12, "Existe proteção das partes movéis"),
                ChecklistItemDef(13, "Existe proteção das partes energizadas"),
                ChecklistItemDef(14, "Condições da estrutura e carcaça do equipamentos"),
                ChecklistItemDef(15, "Sistema de fixação da base da central de concreto"),
                ChecklistItemDef(16, "Condições do sistema de engate rápido da mangueia"),
                ChecklistItemDef(17, "condições da esteira de transporte de agregados"),
                ChecklistItemDef(18, "Condições de empilhamento do cimento"),
                ChecklistItemDef(19, "Condições de acesso a plataforma de estocagem de cimento"),
                ChecklistItemDef(20, "Segurança do local de carregamento dos caminhões"),
                ChecklistItemDef(21, "Existência de sinalização de segurança"),
            )
        ),
        ChecklistTipo(
            id = "gerador",
            nome = "Gerador",
            titulo = "Formulário de Inspeção Diária de Segurança  (Gerador)",
            itens = listOf(
                ChecklistItemDef(1, "O nível de óleo do motor está adequado?"),
                ChecklistItemDef(2, "Está instalado em local coberto, com restrição de acesso de pessoas não autorizadas?"),
                ChecklistItemDef(3, "Há barreira de contenção construida em material impermeável ?"),
                ChecklistItemDef(4, "Há placas de sinalização advertindo o risco de contato acidental com energia elétrica?"),
                ChecklistItemDef(5, "As transmissões de força mecânica estão protegidas  por anteparos fixos e resistentes?"),
                ChecklistItemDef(6, "O equipametno encontra-se aterrado?"),
                ChecklistItemDef(7, "O tanque de combustível está sem vazamentos e com a tampa fechada?"),
                ChecklistItemDef(8, "O equipameto não apresenta vazamentos de oleo?"),
                ChecklistItemDef(9, "Há extintor de incêndio PQS carregado e dentro da validade?"),
                ChecklistItemDef(10, "O estado geral da carcaça é satisfatório?"),
                ChecklistItemDef(11, "No local há o kit de mitigação?"),
            )
        ),
        ChecklistTipo(
            id = "trator_de_pneu",
            nome = "Trator de Pneu",
            titulo = "Formulário de Inspeção Diária de Segurança  (Trator de Pneu)",
            itens = listOf(
                ChecklistItemDef(1, "Acendimento das luzes do painel"),
                ChecklistItemDef(2, "Acesso a cabine é adequado e está em boas condições de uso"),
                ChecklistItemDef(3, "Condições de uso dos pneus e rodas"),
                ChecklistItemDef(4, "Condições do escapamento"),
                ChecklistItemDef(5, "Condições Gerais da Limpeza"),
                ChecklistItemDef(6, "Crachá do Operador conforme NR 11"),
                ChecklistItemDef(7, "Estado geral da estrutura mecanica (trincas, deformações, etc..)"),
                ChecklistItemDef(8, "Estado Geral dos Vidros"),
                ChecklistItemDef(9, "Existência, Validade, Condições do Casco, carga e fixação do extintor de incêndio"),
                ChecklistItemDef(10, "Fechamento da tampa do tanque de combustivel"),
                ChecklistItemDef(11, "Fixação, Condições do banco do operador"),
                ChecklistItemDef(12, "Funcioamento das luzes de emergência"),
                ChecklistItemDef(13, "Funcionamento da buzina"),
                ChecklistItemDef(14, "Funcionamento das luzes de freio"),
                ChecklistItemDef(15, "Funcionamento das luzes de ré"),
                ChecklistItemDef(16, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(17, "Funcionamento das luzes dianteiras"),
                ChecklistItemDef(18, "Funcionamento das luzes indicadoras de seta (pisca)"),
                ChecklistItemDef(19, "Funcionamento de portas e maçanetas"),
                ChecklistItemDef(20, "Funcionamento do alarme sonoro de ré"),
                ChecklistItemDef(21, "Funcionamento do Cinto de Segurança"),
                ChecklistItemDef(22, "Funcionamento do Sistema de Freio"),
                ChecklistItemDef(23, "Funcionamento do sistema de transmissão"),
                ChecklistItemDef(24, "Funcionamento do Sistema lento e rápido"),
                ChecklistItemDef(25, "Funcionamento dos Retrovisores interno e externo"),
                ChecklistItemDef(26, "Operador Qualificado"),
                ChecklistItemDef(27, "Os EPI´s estão adequado ao risco"),
                ChecklistItemDef(28, "Vazamento de agua, oleo ou combustivel"),
                ChecklistItemDef(29, "Verificar estado geral da cabine"),
                ChecklistItemDef(30, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "p_t_a",
            nome = "P.T.A",
            titulo = "Formulário de Inspeção Diária de Segurança  (Plataforma de Transporte Aéreo - P.T.A)",
            itens = listOf(
                ChecklistItemDef(1, "O operador é treinado na operação da PTA?"),
                ChecklistItemDef(2, "O operador é treinado para trabalho em altura?"),
                ChecklistItemDef(3, "A área está sinalizada e isolada?"),
                ChecklistItemDef(4, "Há distância segura de redes elétricas aéreas?"),
                ChecklistItemDef(5, "Todos estão com cinto de segurança com talabarte?"),
                ChecklistItemDef(6, "Os demais EPI´s estão de adequados?"),
                ChecklistItemDef(7, "O manual do equipamento está disponível para pronta consulta em caso de necessidade?"),
                ChecklistItemDef(8, "Está garantida a estabilidade para evitar tombamento da PTA?"),
                ChecklistItemDef(9, "A capacidade da carga está informada em local visível na PTA?"),
                ChecklistItemDef(10, "Sistema de tranca da porta em funcionamento adequado?"),
                ChecklistItemDef(11, "Braços de levantamento em perfeito estado de conservação?"),
                ChecklistItemDef(12, "Rodas em perfeito estado de conservação?"),
                ChecklistItemDef(13, "Pneus em perfeito estado de conservação?"),
                ChecklistItemDef(14, "Eixo expansivel  do equipamento em perfeito estado de conservação?"),
                ChecklistItemDef(15, "Garda corpo em perfeito estado de conservação, sem folgas?"),
                ChecklistItemDef(16, "Painel de controle em perfeito estado de conservação?"),
                ChecklistItemDef(17, "Painel de comando com botão de parada de emergência adequado?"),
                ChecklistItemDef(18, "Há sistema sonoro automático de sinalização acionado durante a subida e a descida?"),
                ChecklistItemDef(19, "Estado geral de conservação adequado?"),
                ChecklistItemDef(20, "Os sistemas de ar, hidráulico e de combustível estão em adequado funcionamento?"),
                ChecklistItemDef(21, "APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "motosserra",
            nome = "Motosserra",
            titulo = "Formulário de Inspeção Diária de Segurança  (Motosserra)",
            itens = listOf(
                ChecklistItemDef(1, "Verificar existência e funcionamento do freio manual de corrente."),
                ChecklistItemDef(2, "Verificar existência e funcionamento do pino pega corrente"),
                ChecklistItemDef(3, "Verificar existência e condições do protetor de mão direita e de mão esquerda."),
                ChecklistItemDef(4, "Verificar existência e funcionamento da trava de segurança do acelerador."),
                ChecklistItemDef(5, "Verificar condições de conservação e de fechamento do tanque de combustível."),
                ChecklistItemDef(6, "Verificar condições de conservação e de corte da corrente."),
                ChecklistItemDef(7, "Verificar condições de conservação da carcaça."),
                ChecklistItemDef(8, "Verificar condições de lubrificação."),
                ChecklistItemDef(9, "Verificar sinalização de advertência indelével e resistente, em local de fácil leitura e visualização, informando \"O uso inadequado pode provocar acidentes graves e danos à saúde\"."),
                ChecklistItemDef(10, "Verificar a existência e validade da Licença de Porte e Uso (LPU)."),
                ChecklistItemDef(11, "Verificar se o operador é qualificado e se está identificado."),
                ChecklistItemDef(12, "Verificar se há uma cópia do certificado do operador de motosserra na frente de serviço"),
                ChecklistItemDef(13, "Verificar se há na frente de serviço o kit de mitigação exclusivo para motosserra"),
                ChecklistItemDef(14, "Verificar se os materiais para afiação da corrente estão em bainhas"),
                ChecklistItemDef(15, "Verificar se os EPIs estão adequados aos riscos, quando em atividade."),
                ChecklistItemDef(16, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "serra_circular_de_bancada",
            nome = "Serra Circular de Bancada",
            titulo = "Formulário de Inspeção Diária de Segurança  (Serra Circular de Bancada)",
            itens = listOf(
                ChecklistItemDef(1, "A botoeira liga/desliga está em perfeito estado de conservação ?"),
                ChecklistItemDef(2, "O aterramento elétrico da carcaça do motor foi feito?"),
                ChecklistItemDef(3, "Quando ligado o motor apresenta ruídos e vibrações anormais?"),
                ChecklistItemDef(4, "O disco de corte está em prefeito estado (sem avarias, trincas, dentes quebrados, afiado e travado). ?"),
                ChecklistItemDef(5, "A proteção do disco, por coifa, está adequada e em bom estado?"),
                ChecklistItemDef(6, "As  lâmpadas próximas possuem proteção contra impactos provenientes da projeção de partículas ?"),
                ChecklistItemDef(7, "O piso está nivelado, sem depressões ?"),
                ChecklistItemDef(8, "A bancada do equipamento está bem presa e estável?"),
                ChecklistItemDef(9, "Os sistemas de transmissão de força  (correias, polias, etc.) possuem proteção ?"),
                ChecklistItemDef(10, "As correias estão em bom estado, ajuste e sem desgaste ?"),
                ChecklistItemDef(11, "Os eixos estão em perfeito estado de conservação (não apresentam  empeno, agarramentos) e estão devidamente montados sobre o mandril?"),
                ChecklistItemDef(12, "Ha extintor de incêndio em perfeito estado de conservação e bem localizado?"),
                ChecklistItemDef(13, "Há coletor de serragem e o mesmo está em bom estado ?"),
                ChecklistItemDef(14, "O espaço ao redor da serra circular está livre e desobstruído ?"),
                ChecklistItemDef(15, "Há placas de segurança informando os riscos e os EPIs necessários para utilização da máquina?"),
                ChecklistItemDef(16, "Há no equipamento a relação nominal das pessoas (operadores) autorizadas a utilizá-lo?"),
                ChecklistItemDef(17, "Há dispositivo empurrador para auxiliar na operação ?"),
                ChecklistItemDef(18, "Há guia de alinhamento e está em perfeito estado para uso?"),
                ChecklistItemDef(19, "As tomadas estão em bom estado de conservação, com tampas de proteção e  sem fios desencapados?"),
                ChecklistItemDef(20, "A chave de parada de emergência  está em perfeitos estado ?"),
                ChecklistItemDef(21, "O equipamento possui botão de parada de emergência conforme NR 12"),
                ChecklistItemDef(22, "Verificar se os EPIs estão adequados aos riscos, quando em atividade."),
                ChecklistItemDef(23, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "policorte",
            nome = "Policorte",
            titulo = "Formulário de Inspeção Diária de Segurança  (POLICORTE)",
            itens = listOf(
                ChecklistItemDef(1, "A instalação do equipamento está em superfície regular e firme?"),
                ChecklistItemDef(2, "O disco de corte encontra-se livre de rachaduras?"),
                ChecklistItemDef(3, "A proteção do disco está  adequada e segura?"),
                ChecklistItemDef(4, "Há nas proximidades placas indicativa de uso obrigatório de EPI?"),
                ChecklistItemDef(5, "As partes móveis, como correias, etc, estão adequadamente protegidas?"),
                ChecklistItemDef(6, "A máquina está com aterramento elétrico?"),
                ChecklistItemDef(7, "O local de tabalho está limpo e organizado?"),
                ChecklistItemDef(8, "A fiação elétrica está adequadamente protegida ?"),
                ChecklistItemDef(9, "Há identificação dos autorizados a operação do equipamento?"),
                ChecklistItemDef(10, "As partes móves estão protegidas?"),
                ChecklistItemDef(11, "O local é iluminado ?"),
                ChecklistItemDef(12, "A botoeira liga/desliga está em perfeito estado de conservação ?"),
                ChecklistItemDef(13, "Ha extintor de incêndio em perfeito estado de conservação e bem localizado?"),
                ChecklistItemDef(14, "O equipamento possui botão de parada de emergência conforme NR 12"),
                ChecklistItemDef(15, "Verificar se os EPIs estão adequados aos riscos, quando em atividade."),
                ChecklistItemDef(16, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "betoneira",
            nome = "Betoneira",
            titulo = "Formulário de Inspeção Diária de Segurança  (BETONEIRA ESTACIONÁRIA)",
            itens = listOf(
                ChecklistItemDef(1, "O botão liga e desliga ao alcance do operador"),
                ChecklistItemDef(2, "O equipamento apresenta aterramento da carcaça, motor e demais partes metálicas"),
                ChecklistItemDef(3, "A chave blindada ou disjuntor identificado"),
                ChecklistItemDef(4, "Os cabos elétricos estão protegidos"),
                ChecklistItemDef(5, "As partes moveis estão protegidas"),
                ChecklistItemDef(6, "Os freios em bom estado de uso"),
                ChecklistItemDef(7, "Possui dispositivo contra queda acidental da caçamba"),
                ChecklistItemDef(8, "Os dentes da gremalheira estão em perfeito estado"),
                ChecklistItemDef(9, "Apresenta placas de segurança uso deEPI/identificação do operador"),
                ChecklistItemDef(10, "Apresenta extintor de incêndio no local"),
                ChecklistItemDef(11, "Aparesenta cobertura contra intempérie/piso nivelado"),
                ChecklistItemDef(12, "Há espaço de ciruculção em torno da betoneira"),
                ChecklistItemDef(13, "As lâmpadas estão protegidas contra impacto"),
                ChecklistItemDef(14, "O operador está treinado pela segurança e possui crachá de identificação"),
                ChecklistItemDef(15, "Os EPI´s estão  em bom estado e usado pelo operador e auxiliares"),
                ChecklistItemDef(16, "Os cabos de aço/carreias estão em bom estado e devidamente fixados"),
                ChecklistItemDef(17, "A betoneira é limpa diariamente"),
                ChecklistItemDef(18, "As partes elétricas estão protegidas contra agua, ou umidade"),
                ChecklistItemDef(19, "Na limpeza do equipamento a tomada está  desligada e desconectada da alimentação elétrica"),
                ChecklistItemDef(20, "O equipamento possui botão de parada de emergência conforme NR 12"),
                ChecklistItemDef(21, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "compactador_percuss_o",
            nome = "Compactador Percussão",
            titulo = "Formulário de Inspeção Diária de Segurança  (COMPACTADOR A PERCUSSÃO)",
            itens = listOf(
                ChecklistItemDef(1, "Partida do Equipamento"),
                ChecklistItemDef(2, "Acelerador"),
                ChecklistItemDef(3, "Afogador do Equipamento (Corte da Gasolina)"),
                ChecklistItemDef(4, "Chave Reguladora de Compactação"),
                ChecklistItemDef(5, "Funcionamento do Motor"),
                ChecklistItemDef(6, "Suporte de Operação"),
                ChecklistItemDef(7, "Fixação dos Cabos"),
                ChecklistItemDef(8, "Fixação do Condutores de Combustivel e Filto (mangueira)"),
                ChecklistItemDef(9, "Estado da Sanfona de Proteção"),
                ChecklistItemDef(10, "Estado da Fixação da Sapata"),
                ChecklistItemDef(11, "Estado do Tanque de Combustivel"),
                ChecklistItemDef(12, "Estado dos Condotores Elétricos (Vela)"),
                ChecklistItemDef(13, "Estado das Braçadeiras Superior e Inferior"),
                ChecklistItemDef(14, "Estado dos Suporte de Amortecimento"),
                ChecklistItemDef(15, "Estado do Suporte de Içamento"),
                ChecklistItemDef(16, "Identificação do Equipamento"),
                ChecklistItemDef(17, "Vazamentos"),
                ChecklistItemDef(18, "Operador Qualificado"),
                ChecklistItemDef(19, "Os EPI´s estão  em bom estado e usado pelo operador e auxiliares"),
                ChecklistItemDef(20, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "placa_prancha_vibrat_ria",
            nome = "Placa-Prancha Vibratória",
            titulo = "Formulário de Inspeção Diária de Segurança  (PLACA/PRANCHA VIBRATÓRIA)",
            itens = listOf(
                ChecklistItemDef(1, "O guidão encontra-se em bom estado de conservação? (sem deformidades)"),
                ChecklistItemDef(2, "O equipamento apresenta o silenciador e está funcionando?"),
                ChecklistItemDef(3, "O equipamento possui filtro de ar?"),
                ChecklistItemDef(4, "O equipamento apresenta as proteções do motor?"),
                ChecklistItemDef(5, "As alças de elevação encontram em perfeito estado?"),
                ChecklistItemDef(6, "O reservatório de combustivel está em perfeito estado? (sem vazamentos)"),
                ChecklistItemDef(7, "O reservatório de água está em perfeito estado? (sem vazamentos)"),
                ChecklistItemDef(8, "O vibrador encontra-se em perfeito estado? (sem deformidades)"),
                ChecklistItemDef(9, "A placa encontra-se em perfeito estado?"),
                ChecklistItemDef(10, "A base do motor está em perfeito estado?"),
                ChecklistItemDef(11, "O equipamento contem a tampa (proteção) da correia?"),
                ChecklistItemDef(12, "O equipamento contém amortecedor de vibração?"),
                ChecklistItemDef(13, "O Motor encontra-se em bom estado (sem vazamentos, avarias)?"),
                ChecklistItemDef(14, "O cordel de partida encontra-se em perfeito estado ? (sem deformações)"),
                ChecklistItemDef(15, "Os EPI´s estão  em bom estado e usado pelo operador e auxiliares"),
                ChecklistItemDef(16, "Operador encontra-se treinado"),
                ChecklistItemDef(17, "Verificar se há APR da atividade"),
            )
        ),
        ChecklistTipo(
            id = "ferramentas_el_tricas",
            nome = "Ferramentas Elétricas",
            titulo = "Formulário de Inspeção Diária de Segurança  LIXADEIRA/MAQUITA/ESMERILHADEIRA/SERRA CIRCULAR/ FURADEIRA ELÉTRICA",
            itens = listOf(
                ChecklistItemDef(1, "O executante encontra-se treinado e habilitado?"),
                ChecklistItemDef(2, "O executante encontra-se identificado por crachá?"),
                ChecklistItemDef(3, "O equipamento está fixado em bancada?"),
                ChecklistItemDef(4, "Há sistema que impeça o contato do disco com a bancada?"),
                ChecklistItemDef(5, "Existe morça para prender material a ser cortado?"),
                ChecklistItemDef(6, "Existe proteção de parte do disco?"),
                ChecklistItemDef(7, "A carcaça encontra-se sem rachadura?"),
                ChecklistItemDef(8, "O equipamento emite vibrações anormais?"),
                ChecklistItemDef(9, "O botão liga desliga está em perfeito estado de funcionamento?"),
                ChecklistItemDef(10, "O plug para alimentação elétrica encontra-se em pefeito estado de conservação?"),
                ChecklistItemDef(11, "O cabo elétrico encontra-se sem emendas?"),
                ChecklistItemDef(12, "O cabo está com dupla isolação?"),
                ChecklistItemDef(13, "O equipamento encontra-se aterrado e com disjuntor?"),
                ChecklistItemDef(14, "O disco encontra-se sem tricas / ou fissuras?"),
                ChecklistItemDef(15, "Há chave para troca do disco e está em boas condições?"),
                ChecklistItemDef(16, "O disco esta devidamente ajustado ao eixo?"),
                ChecklistItemDef(17, "Há velocidade de rotação do disco é superior a do equipamento?"),
                ChecklistItemDef(18, "Odisco foi testado antes da instalação?"),
                ChecklistItemDef(19, "Os EPI´S estão disponivéis (capacete acoplado com viseira e protetor auricular, luvas, botina de segurança, avental/mangote, perneira de raspa)?"),
                ChecklistItemDef(20, "Há biombo de proteção contra projeção de fagulhas/partículas?"),
                ChecklistItemDef(21, "O disco esta sendo usado para a atividade recomendado pelo fabricante?"),
                ChecklistItemDef(22, "Na troca do disco a tomada é desconectada da alimentação elétrica?"),
                ChecklistItemDef(23, "Existe identificação no local de instalação de pessoal autorizado a usar o equipamento?"),
                ChecklistItemDef(24, "Há extintor na area?"),
                ChecklistItemDef(25, "Verificar se há APR da atividade?"),
            )
        ),
        ChecklistTipo(
            id = "minicarregadeira_bobocat",
            nome = "Minicarregadeira (bobocat)",
            titulo = "Formulário de Inspeção Diária de Segurança  MINI-CARREGADEIRA(BOBCAT)",
            itens = listOf(
                ChecklistItemDef(1, "O cabeçote, cabine, lança, trava e braço de articulação estão livres de avarias e danos (trincas, dentes quebrados, etc)?"),
                ChecklistItemDef(2, "Os joystick de comando (giro, lança, direção traseira), sistema operacional e computadorizado estão funcionando?"),
                ChecklistItemDef(3, "Os assentos fixos com cinto de segurança (três pontos na frente) e enconsto de cabeça?"),
                ChecklistItemDef(4, "A buzina, sistema de freios, dispositivos de comando e chave geral para desenergização do sistema elétrico funcionando?"),
                ChecklistItemDef(5, "Os pneus  dianteiros e traseiros estão em bom estado de conservação?"),
                ChecklistItemDef(6, "Há extintor de incêndio compativel, carregado e na validade?"),
                ChecklistItemDef(7, "O sistema hidráulico, conexões, mangueiras, etc. se apresenta em boas condições sem vazamentos e com conexões por dispositivos específicos?"),
                ChecklistItemDef(8, "A luz de freio, alarme sonoro de ré, luz de marcha à ré, e transformação dos faróis alto-baixo estão funcionando?"),
                ChecklistItemDef(9, "O operador possui identificação ( cracha)?"),
                ChecklistItemDef(10, "O operador é habilitado e qualificado?"),
                ChecklistItemDef(11, "Os epi´s estão adequados e em bom estado de conservação?"),
                ChecklistItemDef(12, "O Sistema de ar-condicionado está funcionando?"),
                ChecklistItemDef(13, "Verificar se há APR da atividade?"),
            )
        ),
        ChecklistTipo(
            id = "cinto_de_seguran_a_pararqued",
            nome = "Cinto de Segurança  - pararqued",
            titulo = "Formulário de Inspeção Diária de Segurança CINTO DE SEGURANÇA TIPO PARARQUEDISTA",
            itens = listOf(
                ChecklistItemDef(1, "O cinto encontra-se limpo, isento de óleo e graxa?"),
                ChecklistItemDef(2, "O cinto encontra-se completo? (não existe ausência de partes,componentes)"),
                ChecklistItemDef(3, "O cinto está em perfeito estado de conservação sem partes deformadas,partidas,fendidas ou frouxas?"),
                ChecklistItemDef(4, "As argolas estão em boas condições e sem trincas?"),
                ChecklistItemDef(5, "O talabarte do cinto encontra-se em perfeito estado de conservação, sem cortes,fios rompidos,ilhós oxidado, ressecado ou corroído por produtos químicos?"),
                ChecklistItemDef(6, "O mosquetão está travando corretamente?"),
                ChecklistItemDef(7, "Os ilhoses e fivelas do cinto de segurança estão em bom estado, e não apresentam sem sinais de ferrugem?"),
                ChecklistItemDef(8, "A trava do gancho encontra-se em perfeito estado? (,trava quebrada,parte metálica oxidada,etc.)"),
                ChecklistItemDef(9, "As fitas do cinto e do talabarte estão em bom estado e não apresentam avarias e cortes?"),
                ChecklistItemDef(10, "As fitas do cinto e do talabarte estão em perfeito estado não apresentando desfiamento?"),
                ChecklistItemDef(11, "Os pontos de costura estão em perfeito estado sem descostura?"),
                ChecklistItemDef(12, "O número do CA está identificado com gravação visível?"),
            )
        ),
        ChecklistTipo(
            id = "vibrador_de_concreto",
            nome = "Vibrador de Concreto",
            titulo = "Formulário de Inspeção Diária de Segurança VIBRADOR DE CONCRETO",
            itens = listOf(
                ChecklistItemDef(1, "AS PARTES MOVEIS ESTÃO PROTEGIDAS?"),
                ChecklistItemDef(2, "AS PARTES COM RISCO DE QUEIMADURA ESTÃO PROTEGIDAS?"),
                ChecklistItemDef(3, "O TAMPA DO COMBUSTÍVEL ESTÁ VEDANDO CORRETAMENTE?"),
                ChecklistItemDef(4, "A SINALIZAÇÃO INFORMANDO O RISCO DE INCÊNDIO E QUEIMADURA?"),
                ChecklistItemDef(5, "O CORDEL DE PARTIDA ENCONTRA-SE EM BOM ESTADO DE CONSERVAÇÃO E FUNCIONAMENTO?"),
                ChecklistItemDef(6, "EXISTE AFOGADOR E ENCONTRASE EM BOM ESTADO DE CONSEVAÇÃO?"),
                ChecklistItemDef(7, "AS ALÇAS ESTÃO EM BOM ESTADO DE CONSERVAÇÃO SEM TRINCAS OU SOLDAS IRREGULARES?"),
                ChecklistItemDef(8, "EXISTE PONTO DE ATERRAMENTO NO EQUIPAMENTO?"),
                ChecklistItemDef(9, "O ENGATE DO MANGOTE ENCONTRA-SE EM BOM ESTADO?"),
                ChecklistItemDef(10, "O MANGOTE ENCONTRA-SE EM BOM ESTADO DE CONSERVAÇÃO (SEM RACHADURAS)"),
                ChecklistItemDef(11, "O VIBRADOR DE IMERSÃO ENCONTRA-SE SEM RACHADURAS, TRINCAS OU DEFORMIDADES?"),
                ChecklistItemDef(12, "O VIBRADOR DE IMERSÃO ESTÁ EM PERFEITO ESTADO DE FUNCIONAMENTO?"),
                ChecklistItemDef(13, "OS COLABORADORES ESTÃO COM OS EPIS NECESSÁRIOS?"),
                ChecklistItemDef(14, "OS RISCOS ESTÃO CONTEMPLADOS NA APR"),
            )
        ),
        ChecklistTipo(
            id = "rock_drill",
            nome = "Rock Drill",
            titulo = "Rock Drill",
            itens = listOf(
                ChecklistItemDef(1, "Chassi"),
                ChecklistItemDef(2, "Comandos pneumáticos"),
                ChecklistItemDef(3, "Dispositivos antichicoteamento"),
                ChecklistItemDef(4, "Esteira"),
                ChecklistItemDef(5, "Esticador de esteira"),
                ChecklistItemDef(6, "Extintor"),
                ChecklistItemDef(7, "Guia de lança"),
                ChecklistItemDef(8, "Mangueiras hidráulicas"),
                ChecklistItemDef(9, "Mangueiras pneumáticas"),
                ChecklistItemDef(10, "Motor bomba hidráulica"),
                ChecklistItemDef(11, "Motor de avanço/redutor"),
                ChecklistItemDef(12, "Motor de tração"),
                ChecklistItemDef(13, "Plataforma de operação"),
                ChecklistItemDef(14, "Condições do Compressor"),
            )
        ),
        ChecklistTipo(
            id = "motobomba",
            nome = "Motobomba",
            titulo = "Formulário de Inspeção Diária de Segurança MOTOBOMBA",
            itens = listOf(
                ChecklistItemDef(1, "AS PARTES MOVEIS ESTÃO PROTEGIDAS?"),
                ChecklistItemDef(2, "AS PARTES COM RISCO DE QUEIMADURA ESTÃO PROTEGIDAS?"),
                ChecklistItemDef(3, "O TAMPA DO COMBUSTÍVEL ESTÁ VEDANDO CORRETAMENTE?"),
                ChecklistItemDef(4, "A SINALIZAÇÃO INFORMANDO O RISCO DE INCÊNDIO E QUEIMADURA?"),
                ChecklistItemDef(5, "O CORDEL DE PARTIDA ENCONTRA-SE EM BOM ESTADO DE CONSERVAÇÃO E FUNCIONAMENTO?"),
                ChecklistItemDef(6, "EXISTE AFOGADOR E ENCONTRASE EM BOM ESTADO DE CONSEVAÇÃO?"),
                ChecklistItemDef(7, "AS ALÇAS ESTÃO EM BOM ESTADO DE CONSERVAÇÃO SEM TRINCAS OU SOLDAS IRREGULARES?"),
                ChecklistItemDef(8, "EXISTE PONTO DE ATERRAMENTO NO EQUIPAMENTO?"),
                ChecklistItemDef(9, "O ENGATE DO MANGOTE ENCONTRA-SE EM BOM ESTADO?"),
                ChecklistItemDef(10, "O MANGOTE ENCONTRA-SE EM BOM ESTADO DE CONSERVAÇÃO (SEM RACHADURAS)"),
                ChecklistItemDef(11, "OS COLABORADORES ESTÃO COM OS EPIS NECESSÁRIOS?"),
                ChecklistItemDef(12, "OS RISCOS ESTÃO CONTEMPLADOS NA APR"),
            )
        ),
    )

    fun porId(id: String): ChecklistTipo? = tipos.find { it.id == id }

    private val idsEquipamento = setOf(
        "retroescavadeira",
        "minicarregadeira",
        "minicarregadeira_bobocat",
        "rolo_compactador",
        "p_carregadeira",
        "escavadeira_hidraulica",
        "motoniveladora",
        "trator_de_esteira",
        "trator_de_pneu",
        "central_de_concreto",
        "gerador",
        "p_t_a",
        "motosserra",
        "serra_circular_de_bancada",
        "policorte",
        "betoneira",
        "compactador_percuss_o",
        "placa_prancha_vibrat_ria",
        "ferramentas_el_tricas",
        "cinto_de_seguran_a_pararqued",
        "vibrador_de_concreto",
        "rock_drill",
        "motobomba",
    )

    fun ehEquipamento(tipoId: String): Boolean = tipoId in idsEquipamento

    fun rotuloCondutor(tipoId: String): String =
        if (ehEquipamento(tipoId)) "Operador" else "Motorista"

    fun rotuloAssinaturaCondutor(tipoId: String): String =
        rotuloCondutor(tipoId).uppercase()
}
